import React, { useEffect, useState } from 'react';
import { useFormikContext, ErrorMessage } from 'formik';
import Item from '../../../components/Form/Item';
import { Select } from 'antd';
import axios from '../../../util/Api';

const TrainingField = () => {
  return (
    <>
      <Category />
      <Field />
    </>
  );
}

export default TrainingField;

const Field = () => {
  const formik = useFormikContext();
  const [loading, setLoading] = useState(true);
  const [fields, setFields] = useState([]);

  useEffect(() => {
    if (formik.values.field.category) {
      setLoading(true);
      const url = `/master/training-fields?category=${formik.values.field.category}`;
      axios.get(url).then(resp => {
        setFields(resp.data);
        setLoading(false);
      }).catch(err => {});
    }
  }, [formik.values.field.category]);

  return (
    <Item name="Judul Training">
      <Select
        value={formik.values.field.title}
        onChange={(value) => formik.setFieldValue("field.title", value)}
        placeholder={formik.values.field.category ? `Pilih Judul Training` : `Pilih Bidang Training Terlebih Dahulu`}
        loading={loading && formik.values.field.category}
        showSearch
        optionFilterProp="label"
      >
        {fields.map((field, key) => {
          return <Select.Option value={field.id} key={`field-field-${key}`} label={field.name}>
            {field.name}
          </Select.Option>
        })}
      </Select>
      <ErrorMessage component="div" className="gx-text-danger" name="field.title" />
    </Item>
  );
}
const Category = () => {
  const formik = useFormikContext();
  const [loading, setLoading] = useState(true);
  const [categories, setCategories] = useState([]);

  useEffect(() => {
    setLoading(true);
    const url = `/master/training-categories`;
    axios.get(url).then(resp => {
      setCategories(resp.data);
      setLoading(false);
    }).catch(err => {});
  }, []);

  return (
    <Item name="Bidang Training">
      <Select
        defaultValue={formik.values.field.category}
        onChange={(value) => {
          formik.setFieldValue("field.category", value);
          formik.setFieldValue("field.title", undefined);
        }}
        placeholder="Pilih Bidang Training"
        loading={loading}
      >
        {categories.map((category, key) => {
          return <Select.Option value={category.id} key={`category-${key}`}>
            {category.name}
          </Select.Option>
        })}
      </Select>
      <ErrorMessage component="div" className="gx-text-danger" name="field.category" />
    </Item>
  );
}